(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('PragaModalService', PragaModalServiceFactory);

  PragaModalServiceFactory.$inject = [
    '$uibModal',
    '$q'
  ];

  // eslint-disable-next-line max-lines-per-function
  function PragaModalServiceFactory($uibModal, $q) {
    const service = {
      open,
      findSelected,
      mergePragas
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function open(pragas, preSelected) {
      const modal = $uibModal.open({
        controller: 'PragaModalCtrl',
        controllerAs: 'ctrl',
        resolve: {
          pragas: () => pragas,
          preSelected: () => preSelected
        },
        templateUrl: 'views/_praga-modal.html'
      });

      return modal.result;
    }

    function findSelected(list, selected) {
      return (selected || []).map((praga) => _.find(list, {
        id: praga.item_id || praga.item_codigo || praga.id || praga.cd_item
      }));
    }

    function mergePragas(selection, current) {
      return $q((resolve) => {
        if (current && current.length) {
          current.forEach((praga) => {
            const idx = _.findIndex(selection, { id: praga.id });
            if (idx > -1) {
              return selection.splice(idx, 1);
            }
            current.splice(current.indexOf(praga), 1);
          });
        }
        resolve(selection);
      });
    }
  }
}());
